import { WALLET_TYPES } from './walletTypes';

export const getTransactionInformation = (walletType, last4, cardEndingTranslation = '') => {
  if (walletType && Object.values(WALLET_TYPES).includes(walletType)) {
    return ` - ${walletType}`;
  }

  if (last4) {
    return ` - ${cardEndingTranslation} ${last4}`;
  }

  return null;
};
